const MUC = [
  { mau: 'var(--color-cham-info)', nhan: 'Chờ kiểm duyệt / đã lên lịch' },
  { mau: 'var(--color-cham-warn)', nhan: 'Thiếu thumbnail / nhạc chưa duyệt' },
  { mau: 'var(--color-cham-ok)', nhan: 'Đã đăng' },
  { mau: 'var(--color-cham-tat)', nhan: 'Nháp' },
];

/** Chú thích màu của thẻ bài đăng, theo ảnh docs/design/lich-dang.png. */
export function ChuThichMau() {
  return (
    <ul className="mb-4 flex flex-wrap items-center gap-5">
      {MUC.map((m) => (
        <li key={m.nhan} className="flex items-center gap-2 text-co-ban text-chu-phu">
          <span
            className="inline-block size-2.5 rounded-[3px]"
            style={{ backgroundColor: m.mau }}
            aria-hidden="true"
          />
          {m.nhan}
        </li>
      ))}
    </ul>
  );
}
